import { TestStatus } from '@dbt-labs/dbt-dag';

import { FreshnessStatus } from '@/__generated__/graphql';

export const maxFreshnessStatus = (
  a: FreshnessStatus | undefined | null,
  b: FreshnessStatus | undefined | null,
): FreshnessStatus | undefined => {
  if (a === FreshnessStatus.Error || b === FreshnessStatus.Error) {
    return FreshnessStatus.Error;
  }
  if (a === FreshnessStatus.Warn || b === FreshnessStatus.Warn) {
    return FreshnessStatus.Warn;
  }
  if (a === FreshnessStatus.Pass || b === FreshnessStatus.Pass) {
    return FreshnessStatus.Pass;
  }
  return undefined;
};

export const maxTestStatus = (
  a: TestStatus | undefined,
  b: TestStatus | undefined,
): TestStatus | undefined => {
  if (a === 'fail' || b === 'fail') {
    return 'fail';
  }
  if (a === 'error' || b === 'error') {
    return 'error';
  }
  if (a === 'warn' || b === 'warn') {
    return 'warn';
  }
  if (a === 'pass' || b === 'pass') {
    return 'pass';
  }
  if (a === 'skipped' || b === 'skipped') {
    return 'skipped';
  }
  return undefined;
};
